// extracted by mini-css-extract-plugin
module.exports = {"moduleBtnDone":"course-detail-page_moduleBtnDone__3OZGP","moduleBtnReset":"course-detail-page_moduleBtnReset__2N-tG"};